module.exports = __webpack_public_path__ + "static/brand_finelite_banner - Copia-045d8a11cf1a06f650f49dd98e1c8ce6.png";